






































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { TbInventory } from '@/http';
import { dialogPanel,NumberKeyboard,logoutPanel,calendarPanel } from "@/components"
import dayjs from 'dayjs';
import { Toast } from 'vant';
import inventoryDetail from "./inventoryDetail.vue";
@Component({ 
    components: {
        dialogPanel,NumberKeyboard,logoutPanel,calendarPanel,inventoryDetail
    },
})
export default class inventory extends Vue {
   
    public $refs: {
    };

    /**分类列表 */
    classList=[]

    /**查询项 */
    searchValue={
        result:null,
        start:"",
        end:"",
        skip:0,
        count:10,
    }
    /**状态下拉 */
    showStatusPopover = false;
    statusOptions=[
        {
            label:'全部盘点结果',
            value:null,
        },
        {
            label:'库存盘平结果',
            value:1,
        },
        {
            label:'库存盘盈结果',
            value:2,
        },
        {
            label:'库存盘亏结果',
            value:3,
        },
    ]

    /**时间控件 */
    pickerShow = false;
    startDate="";
    endDate="";

    /**列表展示
     * 1:图
     * 2：表格
     */
    showType=1;

    userInfo:any={};

    /**列表加载相关 */
    refreshing= false;
    loading = false;
    finished = false;
    list=[];
    total=0;
    currentPage=1
    totalStock=0;

 
   
    showRolePopover = false;

    /**提示弹窗 */
    tipShow = false;
    tipTitle ="";
    tipText="";
    confirmText="";
    cancelText="";
    btnNums=1;
    tipType=1;
    deletId="";
    isEdit = false;
    

    created() {
        
    }

    async mounted(){
        this.userInfo = JSON.parse(localStorage.getItem('padUserinfo'));
    }

    /**上架状态 */
    get getRoleStatus(){
        let str = ""
        str = this.statusOptions.findIndex(v=>v.value==this.searchValue.result)>-1?this.statusOptions.find(v=>v.value==this.searchValue.result).label:'';
        return str;
    }
   
    async changeStatusXL(item){
        this.searchValue.result = item.value;
        this.showStatusPopover = false;
        await this.getList();
    }
   
    /**下拉刷新 */
    onRefresh(){
        // 清空列表数据
      this.finished = false;
       // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.searchValue.skip=0;
      this.searchValue.count=10;
      this.currentPage = 1;
      this.loadMore();
    }
    /**触底加载 */
    async loadMore(){
            if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
            }
            

            let s = this.searchValue.count;
            let res = await  TbInventory.GetTbInventoryList(Object.assign({},this.searchValue,{
                shopId:this.userInfo.shopId
            }))
            this.list = this.searchValue.skip==0? res.items.map(v=>{
                return{
                    ...v,
                    createTime:dayjs(v.createTime).format("YYYY-MM-DD")
                }
            }):this.list.concat(res.items.map(v=>{
                return{
                    ...v,
                    createTime:dayjs(v.createTime).format("YYYY-MM-DD")
                }
            }));
            this.total  = res.totalCount;
            this.currentPage++;
            this.searchValue.skip = (this.currentPage - 1) * s;
            this.loading = false;
            if (this.list.length >= this.total) {
            this.finished = true;
            console.log('list',this.list);
            
            }
    }
    /**获取商品列表 */
    async getList(){
        this.onRefresh();
        // this.finished = false;
        // this.list = [];
        // this.searchValue.skip=0;
        // this.searchValue.count=10;
        // this.total = 0;
        // this.currentPage = 1;

        // let res = await  TbInventory.GetTbInventoryList(Object.assign({},this.searchValue,{
        //     shopId:this.userInfo.shopId
        // }))
        // this.list = res.items.map(v=>{
        //     return{
        //         ...v,
        //         createTime:dayjs(v.createTime).format("YYYY-MM-DD")
        //     }
        // });
        // this.total  = res.totalCount;
    }
    /**重置 */
    resetSearch(){
        this.searchValue={
            result:null,
            start:"",
            end:"",
            skip:0,
            count:10,
        }
        this.startDate = "";
        this.endDate = "";
        this.getList();
    }
   
    
    
  
    /**提示弹窗 */
    async tipConfirm(){
        if(this.tipType==1){
        }
        this.tipShow = false;
    }
    tipCancel(){
        this.tipShow = false;
    }
   
    /**发起盘点*/
    addPd(){
        localStorage.setItem('allotactive','1');
        this.$router.push("/pad/stock/addInventory");
    }

    openselDate() {
        this.pickerShow = true;
    }
    /**确定选择时间 */
    onselConfirm(date){
        const [start, end] = date;
        this.startDate = dayjs(start).format("YYYY-MM-DD");
        this.endDate = dayjs(end).format("YYYY-MM-DD");
        this.searchValue.start = dayjs(start).format("YYYY-MM-DD") + " " + "00:00:00";
        this.searchValue.end = dayjs(end).format("YYYY-MM-DD") + " " + "23:59:59";
        this.pickerShow = false;
        this.getList();
    }
    closeTime(){
        this.pickerShow = false;
    }
    viewDetail(item){
        this.$refs['inventoryDetail'].showFun(item.id);
    }
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/stock/components/inventory.vue